// En tu slice de Redux, por ejemplo, fathersSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const getFatherInfoThunk = createAsyncThunk(
  'fathers/getFatherInfo',
  async (ciParent, thunkAPI) => {
    try {
      const response = await axios.get(`/students/getFatherInfo/${ciParent}`); // Ajusta la URL según tu API
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Sin información');
    }
  }
);

const fathersSlice = createSlice({
  name: 'fathers',
  initialState: {
    father: null,
    tooltip: {
      visible: false,
      message: ''
    },
    loading: false,
    error: null
  },
  reducers: {
    hideTooltip: (state) => {
      state.tooltip.visible = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFatherInfoThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFatherInfoThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.father = action.payload;
      })
      .addCase(getFatherInfoThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.tooltip.visible = true;
        state.tooltip.message = action.payload;
      });
  }
});

export const { hideTooltip } = fathersSlice.actions;
export default fathersSlice.reducer;
